<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="payModal" :destroy-on-close="false" width="800px">
		<div slot="title">
			<div class="flex" style="align-items: center">
				<h3 class="tab-title">支付信息</h3>
				<div class="countdown-timer">
					<span v-if="countdown > 0" class="timer-text">订单将在 {{ formatTime(countdown) }} 后失效，请尽快支付！</span>
					<span v-else class="timer-expired">订单已失效，请刷新重新生成二维码！</span>
				</div>
			</div>
		</div>
		<el-tabs v-model="activeName" style="text-align: center" type="card">
			<el-tab-pane label="微信支付" name="1">
				<div class="tab-pane-left">
					<div>扫一扫付款（元）</div>
					<div class="money">{{ total }}</div>
					<div class="qrcode-container">
						<div id="wx-qrcode" class="qrcode"></div>
						<div v-if="countdown <= 0" class="qrcode-overlay">
							<div class="refresh-icon" @click="refreshQRCode">
								<i class="el-icon-refresh"></i>
								<span>刷新二维码</span>
							</div>
						</div>
					</div>
					<div>订单号：{{ orderNum }}</div>
				</div>
				<div class="tab-pane-right">
					<div class="tab-pane-right-img">
						<img alt="" src="../../assets/images/weChatPay.png" />
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="支付宝支付" name="2">
				<div class="tab-pane-left">
					<div>扫一扫付款(元)</div>
					<div class="money">{{ total }}</div>
					<div class="qrcode-container">
						<div id="ali-qrcode" class="qrcode"></div>
						<div v-if="countdown <= 0" class="qrcode-overlay">
							<div class="refresh-icon" @click="refreshQRCode">
								<i class="el-icon-refresh"></i>
								<span>刷新二维码</span>
							</div>
						</div>
					</div>
					<div>订单号:{{ orderNum }}</div>
				</div>
				<div class="tab-pane-right">
					<div class="tab-pane-right-img">
						<img alt="" src="../../assets/images/aliPay.png" />
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="对公转账" name="3">
				<div style="display: flex">
					<div class="tab-pane-left tab-pane-text">
						<div>
							金额：<b>{{ total }}元</b>
						</div>
						<div>
							订单号：<b>{{ orderNum }}</b>
						</div>
						<div class="pay-title" style="text-align: left; font-size: 16px; font-weight: 600">对公转账信息</div>
						<div>单位名称：北京品读文化发展有限公司</div>
						<div>单位银行账号：110060907018010020725</div>
						<div>开户行：交通银行北京胜古园支行</div>
						<div>开户银行行号：301100000494</div>
						<div>汇款识别码：{{ tradeComment }}</div>
						<div>
							<p style="font-size: 16px; font-weight: 600">注意事项</p>
							<p style="font-size: 14px">1. 请务必在转账备注中<span style="color: red">填写汇款识别码</span>，以便及时核对款项</p>
							<p style="font-size: 14px">2. 若您汇款后3个工作日内订单状态未更新，请您联系客服进行处理</p>
						</div>
					</div>
					<div class="tab-pane-right-img" style="width: 42%">
						<img alt="" src="../../assets/images/dgzz.jpg" style="width: 316px" />
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<div slot="footer">
			<el-button plain size="small" @click="handleClose">关闭</el-button>
		</div>
	</el-dialog>
</template>
<script>
import QRCode from 'qrcodejs2';
import { getFilesPreview, postFilesUpload } from '@/api/file/file';
import TMessage from '@/utils/TMessage';
import User from '@/utils/User';
import { getConsumerOrderPayWechat, getConsumerOrderPayWechatStatus, getConsumerOrderPayAlibaba, getConsumerOrderPayAlibabaStatus, postConsumerOrderPayOfflineTransfer } from '@/api/order/pay';
export default {
	name: 'Pay',
	props: {
		total: {
			type: Number,
			default: 0
		},
		orderNum: {
			type: String,
			default: ''
		},
		tradeComment: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			//支付modal
			payModal: false,
			activeName: '1',
			iframeUrl: '',

			// 5分钟倒计时（300秒）
			countdown: 300,
			// 倒计时定时器
			countdownTimer: null,
			// 支付状态轮询定时器
			paymentTimer: null,
			loading: true,
			// 当前二维码内容
			currentQRCode: '',
			//转账信息
			transferInfo: {
				tradeNo: this.orderNum,
				corporateInfo: '',
				corporateInfoUrl: ''
			}
		};
	},
	watch: {
		//监听modal的显现
		async payModal(val) {
			if (val) {
				try {
					this.countdown = 300;
					// 先执行支付二维码获取方法
					await this.getConsumerOrderPayWechat();
					await this.getConsumerOrderPayAlibaba();
					// 成功后再执行倒计时和轮询逻辑
					this.startCountdown();
					this.startPaymentPolling();
				} catch (error) {
					console.error('支付二维码获取失败:', error);
					this.$message.error('支付二维码获取失败，请重试');
				}
			}
			if (!val) {
				this.clearTimers();
			}
		},
		// 监听倒计时
		countdown(val) {
			if (val <= 0) {
				this.clearTimers();
				// this.$message.warning('订单已失效，请刷新二维码重新支付');
			}
		}
	},
	methods: {
		//出发input标签事件
		updateImg() {
			this.$refs.updateImgInput.click();
		},

		//选择后的事件
		async updateChange(event) {
			let Max_Size = 1024 * 100; //100KB
			let file = event.target.files[0];
			if (file.type === 'image/jpeg' || file.type === 'image/png') {
				if (file.size * 0.0009766 > Max_Size) {
					TMessage.warning('转账凭证大小不能大于100MB，请重新上传');
					return;
				} else {
					let res = await postFilesUpload(file);
					if (res.code == 200) {
						let url = res.data;
						const prefix = '/third/files/info/';
						const key = url.replace(prefix, '');
						this.transferInfo.corporateInfo = key;
						this.getFilesInfo(key);
						TMessage.success('转账凭证上传成功');
					}
				}
			} else {
				TMessage.warning('转账凭证只能上传图片类型，请重新上传');
			}
		},

		// 获取文件详情
		async getFilesInfo(key) {
			try {
				const response = await fetch(`/webL_api/third/files/info/${key}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				const imageUrlData = URL.createObjectURL(blob);
				this.$set(this.transferInfo, 'corporateInfoUrl', imageUrlData);
			} catch (error) {
				console.error('获取图片失败:', error);
				return null;
			}
		},

		handleConfirm() {
			if (!this.transferInfo.corporateInfo) {
				TMessage.warning('请上传转账凭证');
				return;
			} else {
				this.transferInfo.tradeNo = this.orderNum;
				postConsumerOrderPayOfflineTransfer(this.transferInfo).then(res => {
					if (res.code == 200) {
						TMessage.success('转账凭证上传成功');
						this.handleClose();
						this.$emit('successPay');
					}
				});
			}
		},

		// 开始5分钟倒计时
		startCountdown() {
			this.countdownTimer = setInterval(() => {
				this.countdown--;
			}, 1000);
		},
		// 开始支付状态轮询
		startPaymentPolling() {
			this.paymentTimer = setInterval(() => {
				if (this.activeName == '1') {
					this.checkPaymentStatusWx();
				} else {
					this.checkPaymentStatusAli();
				}
			}, 3000);
		},
		// 检查支付状态--微信
		async checkPaymentStatusWx() {
			getConsumerOrderPayWechatStatus(this.orderNum).then(res => {
				if (res.code == 200) {
					if (res.data.payStatus > 1) {
						this.handleClose();
						this.$emit('successPay');
					}
				}
			});
		},
		// 检查支付状态--支付宝
		async checkPaymentStatusAli() {
			getConsumerOrderPayAlibabaStatus(this.orderNum).then(res => {
				if (res.code == 200) {
					if (res.data.payStatus > 1) {
						this.handleClose();
						this.$emit('successPay');
					}
				}
			});
		},
		// 清除所有定时器
		clearTimers() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			}
			if (this.paymentTimer) {
				clearInterval(this.paymentTimer);
				this.paymentTimer = null;
			}
		},

		// 刷新二维码
		async refreshQRCode() {
			this.loading = true;
			this.countdown = 300; // 重置倒计时
			await this.getConsumerOrderPayWechat();
			await this.getConsumerOrderPayAlibaba();
			this.startCountdown();
			this.startPaymentPolling();
		},

		//微信支付
		async getConsumerOrderPayWechat() {
			try {
				let res = await getConsumerOrderPayWechat(this.orderNum);
				if (res.code == 200) {
					this.wxQrcode(res.data);
				}
			} catch (error) {
				this.$message.error('获取支付二维码失败');
				this.loading = false;
			}
		},

		//支付宝支付
		async getConsumerOrderPayAlibaba() {
			try {
				let res = await getConsumerOrderPayAlibaba(this.orderNum);
				if (res.code == 200) {
					// this.iframeUrl = res.data;
					this.aliQrcode(res.data);
				}
			} catch (error) {
				this.$message.error('获取支付二维码失败');
				this.loading = false;
			}
			// this.aliQrcode(res.data);
		},

		//微信支付
		wxQrcode(qrCode) {
			document.getElementById('wx-qrcode').innerHTML = '';
			let qrcode = new QRCode(document.getElementById('wx-qrcode'), {
				width: 198,
				height: 198,
				text: qrCode // 二维码内容
			});
		},

		//支付宝支付
		aliQrcode(qrCode) {
			document.getElementById('ali-qrcode').innerHTML = '';
			let qrcode = new QRCode(document.getElementById('ali-qrcode'), {
				width: 198,
				height: 198,
				text: qrCode // 二维码内容
			});
		},

		// 格式化时间显示（分:秒）
		formatTime(seconds) {
			const minutes = Math.floor(seconds / 60);
			const remainingSeconds = seconds % 60;
			return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
		},

		//关闭支付弹框
		handleClose() {
			this.clearTimers();
			this.payModal = false;
		}
	}
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
	padding-top: 0;
}
.tab-title {
	margin: 0;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
}
.tab-pane-text {
	margin-bottom: 10px;
	font-size: 13px;
	line-height: 26px;
	text-align: left;
}
.money {
	font-size: 26px;
	font-weight: 700;
	color: #f60;
}

.qrcode {
	display: inline-block;
	margin-bottom: 10px;
	overflow: hidden;
	width: 198px;
	height: 198px;
}

/* 二维码容器样式 */
.qrcode-container {
	position: relative;
	display: inline-block;
	margin: 20px 0;
}

.qrcode {
	display: inline-block;
	overflow: hidden;
	width: 198px;
	height: 198px;
}

/* 二维码蒙版样式 */
.qrcode-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.7);
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s ease;
}

.qrcode-overlay:hover {
	background-color: rgba(0, 0, 0, 0.8);
}

/* 刷新图标样式 */
.refresh-icon {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: white;
	font-size: 14px;
}

.refresh-icon i {
	font-size: 32px;
	margin-bottom: 8px;
	transition: transform 0.3s ease;
}

.refresh-icon:hover i {
	transform: rotate(180deg);
}

.countdown-timer {
	margin: 10px 0 10px 20px;
	font-size: 16px;
}

.timer-text {
	color: #e6a23c;
	font-weight: bold;
}

.timer-expired {
	color: #f56c6c;
	font-weight: bold;
}

.action-buttons {
	text-align: center;
}

.pay-title {
	font-size: 16px !important;
	line-height: 26px;
}

.tab-pane-left {
	width: 50%;
	float: left;
}

.tab-pane-text {
	div {
		margin-bottom: 8px;
		font-size: 14px;
		line-height: 26px;
	}

	b {
		font-size: 16px;
		margin: 10px 0;
		color: #f60;
	}
}

.tab-pane-right {
	width: 49%;
	float: left;
	height: 100%;
}

.tab-pane-right-img {
	width: 85%;
	height: 100%;
	margin: 0 auto;
}

.tab-pane-right-img img {
	height: 100%;
	width: 100%;
}
</style>
